import { CompanyAddressFieldNames } from '@contracts/order/fields/CompanyAddressFields';
import { State } from '@contracts/order/valueNormalizers/State';
import {
  DropdownField,
  OptionalStringField,
  StringField,
} from '@src/permitField/PermitFields';
import * as yup from 'yup';

export class CompanyPhysicalAddressField extends StringField {
  public static fieldName = CompanyAddressFieldNames.CompanyPhysicalAddress;
}

export class CompanyPhysicalAddressDetailsField extends OptionalStringField {
  public static fieldName =
    CompanyAddressFieldNames.CompanyPhysicalAddressDetails;
}

export class CompanyPhysicalCityField extends StringField {
  public static fieldName = CompanyAddressFieldNames.CompanyPhysicalCity;
}

export class CompanyPhysicalStateField extends DropdownField {
  public static fieldName = CompanyAddressFieldNames.CompanyPhysicalState;
  public static options = Object.values(State);
  public static validator = yup
    .string()
    .oneOf(CompanyPhysicalStateField.options)
    .required();
}

export class CompanyPhysicalZipCodeField extends StringField {
  public static fieldName = CompanyAddressFieldNames.CompanyPhysicalZipCode;
}

export class CompanyMailingAddressField extends StringField {
  public static fieldName = CompanyAddressFieldNames.CompanyMailingAddress;
}

export class CompanyMailingAddressDetailsField extends OptionalStringField {
  public static fieldName =
    CompanyAddressFieldNames.CompanyMailingAddressDetails;
}

export class CompanyMailingCityField extends StringField {
  public static fieldName = CompanyAddressFieldNames.CompanyMailingCity;
}

export class CompanyMailingStateField extends DropdownField {
  public static fieldName = CompanyAddressFieldNames.CompanyMailingState;
  public static options = Object.values(State);
  public static validator = yup
    .string()
    .oneOf(CompanyMailingStateField.options)
    .required();
}

export class CompanyMailingZipCodeField extends StringField {
  public static fieldName = CompanyAddressFieldNames.CompanyMailingZipCode;
}

export const companyAddressFields = {
  [CompanyPhysicalAddressField.fieldName]:
    CompanyPhysicalAddressField.validator,
  [CompanyPhysicalAddressDetailsField.fieldName]:
    CompanyPhysicalAddressDetailsField.validator,
  [CompanyPhysicalCityField.fieldName]: CompanyPhysicalCityField.validator,
  [CompanyPhysicalStateField.fieldName]: CompanyPhysicalStateField.validator,
  [CompanyPhysicalZipCodeField.fieldName]:
    CompanyPhysicalZipCodeField.validator,
  [CompanyMailingAddressField.fieldName]: CompanyMailingAddressField.validator,
  [CompanyMailingAddressDetailsField.fieldName]:
    CompanyMailingAddressDetailsField.validator,
  [CompanyMailingCityField.fieldName]: CompanyMailingCityField.validator,
  [CompanyMailingStateField.fieldName]: CompanyMailingStateField.validator,
  [CompanyMailingZipCodeField.fieldName]: CompanyMailingZipCodeField.validator,
};
